export default {
	attributes: {
		design: 'basic',
		columns: 1,
		columnBackgroundCustomSizeUnit: '%',
		columnTabletBackgroundCustomSizeUnit: '%',
		columnMobileBackgroundCustomSizeUnit: '%',
		showImage: true,
		imageColorOnHover: false,
		imageShape: 'circle',
		imageSize: 'thumbnail',
		image1Id: 606,
		image1Url: 'https://source.unsplash.com/300x300/?employee',
		image1Alt: 'Name',
		image1ShapeFlipX: false,
		image1ShapeFlipY: false,
		image1ShapeStretch: false,
		image2ShapeFlipX: false,
		image2ShapeFlipY: false,
		image2ShapeStretch: false,
		image3ShapeFlipX: false,
		image3ShapeFlipY: false,
		image3ShapeStretch: false,
		image1Size: 'large',
		image2Size: 'large',
		image3Size: 'large',
		showName: true,
		name1: 'Name',
		nameLineHeightUnit: 'em',
		nameTabletLineHeightUnit: 'em',
		nameMobileLineHeightUnit: 'em',
		showPosition: true,
		position1: 'Position',
		positionLineHeightUnit: 'em',
		positionTabletLineHeightUnit: 'em',
		positionMobileLineHeightUnit: 'em',
		showDescription: true,
		description1: 'Description for this block. Use this space for describing your block. Any text will do.',
		descriptionLineHeightUnit: 'em',
		descriptionTabletLineHeightUnit: 'em',
		descriptionMobileLineHeightUnit: 'em',
		showSocial: true,
		socialLineHeightUnit: 'em',
		socialTabletLineHeightUnit: 'em',
		socialMobileLineHeightUnit: 'em',
		socialUseSocialColors: false,
		socialFacebookUrl: '#',
		socialTwitterUrl: '#',
		socialInstagramUrl: '#',
		socialEmailUrl: 'mailto:my@email.com',
		social1LineHeightUnit: 'em',
		social1TabletLineHeightUnit: 'em',
		social1MobileLineHeightUnit: 'em',
		social1UseSocialColors: true,
		social1FacebookUrl: '#',
		social1TwitterUrl: '#',
		social1InstagramUrl: '#',
		social1EmailUrl: 'mailto:my@email.com',
		social2LineHeightUnit: 'em',
		social2TabletLineHeightUnit: 'em',
		social2MobileLineHeightUnit: 'em',
		social2UseSocialColors: true,
		social2EmailUrl: 'mailto:my@email.com',
		social3LineHeightUnit: 'em',
		social3TabletLineHeightUnit: 'em',
		social3MobileLineHeightUnit: 'em',
		social3UseSocialColors: true,
		social3EmailUrl: 'mailto:my@email.com',
		showFacebook: true,
		showTwitter: true,
		showInstagram: true,
		showPinterest: false,
		showLinkedin: false,
		showYoutube: false,
		showEmail: true,
		imageBottomMargin: 0,
		uniqueClass: 'ugb-3b5c718',
		hideDesktop: false,
		hideTablet: false,
		hideMobile: false,
		showBlockBackground: false,
		blockBackgroundBackgroundCustomSizeUnit: '%',
		blockBackgroundTabletBackgroundCustomSizeUnit: '%',
		blockBackgroundMobileBackgroundCustomSizeUnit: '%',
		topSeparatorDesign: 'wave-1',
		bottomSeparatorDesign: 'wave-1',
		topSeparatorShadow: true,
		bottomSeparatorShadow: true,
		showBlockTitle: false,
		blockTitleLineHeightUnit: 'em',
		blockTitleTabletLineHeightUnit: 'em',
		blockTitleMobileLineHeightUnit: 'em',
		showBlockDescription: false,
		blockDescriptionLineHeightUnit: 'em',
		blockDescriptionTabletLineHeightUnit: 'em',
		blockDescriptionMobileLineHeightUnit: 'em',
	},
}
